import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import * as FileSaver from 'file-saver';
import * as React from 'react';
import * as XLSX from 'sheetjs-style';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  Tooltip,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  Grid,
} from '@mui/material';

import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2';

import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import dayjs from 'dayjs';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import {
  collection,
  getDocs,
  getFirestore,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
  onSnapshot,
  query,
  orderBy,
  limitToLast,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { getStorage, ref, getDownloadURL, uploadBytes } from 'firebase/storage';
import { MuiFileInput } from 'mui-file-input';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// components
import Label from '../../components/label';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/microsite';

import { UserAuth } from '../../context/AuthContext';

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'created', label: 'Created', alignRight: false },
  { id: 'first_name', label: 'First Name', alignRight: false },
  { id: 'last_name', label: 'Last Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'mobile', label: 'Mobile', alignRight: false },
  { id: 'message', label: 'Message', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy2) {
  if (b[orderBy2] < a[orderBy2]) {
    return -1;
  }
  if (b[orderBy2] > a[orderBy2]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy2) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy2)
    : (a, b) => -descendingComparator(a, b, orderBy2);
}

function applySortFilter(array, comparator, query, select) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    if (select === 'title') {
      return filter(array, (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

    if (select === 'id') {
      return filter(array, (_user) => _user.id.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }

    if (select === 'prefix') {
      return filter(array, (_user) => _user.prefix.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
  }
  return stabilizedThis.map((el) => el[0]);
}

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

export default function ProductPage() {
  const { user } = UserAuth();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy2, setOrderBy2] = useState('created');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [row, setRow] = useState([]);

  const [fileUrl, setFileUrl] = useState(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [statusdevice, setStatus] = useState('');
  const [emailaddress, setEmail] = useState('');
  const [cityname, setCity] = useState('');
  const [activationDate, setActivationDate] = useState('');
  const [name, setName] = useState('');
  const [mobileNum, setMobileNum] = React.useState('');
  const [userRole, setUserRole] = useState('super_admin');

  const [titleError, setTitleError] = React.useState(false);
  const [subtitleError, setSubTitleError] = React.useState(false);

  const [title, setTitle] = React.useState('');
  const [subtitle, setSubTitle] = React.useState('');

  const onHandleTitle = (event) => {
    setTitle(event.target.value);
  };

  const onHandleSubTitle = (event) => {
    setSubTitle(event.target.value);
  };

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const [select, setSelect] = useState('id');

  const handleChangeSelect = (event) => {
    setSelect(event.target.value);
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpen2, setDialogOpen2] = useState(false);
  const [dialogOpen3, setDialogOpen3] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [file, setFile] = React.useState(null);
  const [videobg, setVideobg] = React.useState(null);
  const [fileInputError, setFileInputError] = React.useState(false);

  const handleOnChangeUploadfile = (newFile) => {
    setFile(newFile);
  };

  const onHandleUploadVideo = () => {
    let filePass = false;

    if (file && file.type === 'video/mp4') {
      setFileInputError(false);
      filePass = true;
    } else {
      setFileInputError(true);
    }

    if (filePass) {
      setLoading(true);

      const storage = getStorage(app);
      const storageRef = ref(
        storage,
        `videobackground_contact/${Timestamp.fromDate(new Date()).toMillis()}_${file.name.replace(/\s/g, '')}`
      );

      // Get a key for a new Post.

      uploadBytes(storageRef, file).then((snapshot) => {
        getDownloadURL(ref(storage, snapshot.metadata.fullPath)).then((url1) => {
          update(dbref(rtdb, `contactus`), {
            bg_fullPath: url1 || null,
            bg_contentType: snapshot.metadata.contentType || null,
          }).then(() => {
            setLoading(false);
            setFile(null);
          });
          setVideobg(url1);
        });
      });
    }
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogClose2 = () => {
    setDialogOpen2(false);
  };

  const handleDialogClose3 = () => {
    setDialogOpen3(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);

    let titlePass = false;
    let subtitlePass = false;

    if (data.get('title').length > 2) {
      titlePass = true;
      setTitleError(false);
    } else {
      setTitleError(true);
    }

    if (data.get('subtitle').length > 2) {
      subtitlePass = true;
      setSubTitleError(false);
    } else {
      setSubTitleError(true);
    }

    if (titlePass && subtitlePass) {
      update(dbref(rtdb, `contactus`), {
        title: data.get('title'),
        subtitle: data.get('subtitle'),
      }).then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  };

  const handleDialogSubmit = () => {
    update(dbref(rtdb, `contact_registration/${selectedItem.id}`), {
      mobile: mobileNum,
      email: emailaddress || null,
      full_name: name,
      status: statusdevice,
      city: cityname,
      purchase_date: activationDate,
    });

    setDialogOpen(false);
  };

  const handleOnDelete = () => {
    setOpenDelete(true);
    setOpen(false);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleSubmitDelete = async () => {
    const currentIndex = row.map((val) => val.id).indexOf(selectedItem.id);

    if (currentIndex > -1) {
      row.splice(currentIndex, 1);
    }

    remove(child(dbref(rtdb), `contact_registration/${selectedItem.id}`)).then(() => {
      setOpenDelete(false);
    });
  };

  useEffect(() => {
    let _user = '';
    if (user && user.reloadUserInfo && user.reloadUserInfo.customAttributes) {
      _user = JSON.parse(user.reloadUserInfo.customAttributes);
    }
    setUserRole(_user.role);

    const arr = [];
    get(child(dbref(rtdb), `contact_registration`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((doc) => {
            arr.push({
              ...doc.val(),
              id: doc.key,
            });
          });

          setRow(arr);
        } else {
          setRow([]);
          console.log('No data available');
        }

        get(child(dbref(rtdb), `contactus`))
          .then((snapshot) => {
            if (snapshot.exists()) {
              setTitle(snapshot.val().title);
              setSubTitle(snapshot.val().subtitle);
              setVideobg(snapshot.val().bg_fullPath);
              setLoading(false);
            } else {
              setTitle('');
              setSubTitle('');
              setVideobg(null);
              setLoading(false);
              console.log('No data available');
            }
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getUnique = (arr, index) => {
    const unique = arr
      .map((e) => e[index])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  };

  const handleChangeMobileNum = (event) => {
    setMobileNum(event.trim());
  };

  const handleChangeEmail = (event) => {
    setEmail(event.target.value.trim());
  };

  const handleChangeCity = (event) => {
    setCity(event.target.value.trim());
  };

  const handleChangeActivationDate = (event) => {
    setActivationDate(event.target.value.trim());
  };

  const handleChangeName = (event) => {
    setName(event.target.value.trim());
  };

  const downloadExcel = () => {
  try {
    if (!row || row.length === 0) {
      return;
    }

    const sourceData =
      selected.length > 0 ? row.filter((item) => selected.includes(item.id)) : filteredUsers;

    const exportData = sourceData.map((item, index) => ({
      No: index + 1,
      ID: item.id || '',
      Created_Date: item.created ? moment(item.created).format('YYYY-MM-DD') : '',
      Created_Time: item.created ? moment(item.created).format('HH:mm:ss') : '',
      First_Name: item.first_name || '',
      Last_Name: item.last_name || '',
      Email: item.email || '',
      Mobile: item.mobile || '',
      Company: item.company || '',
      Message: item.message || '',
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);

    ws['!cols'] = [
      { wch: 8 },
      { wch: 24 },
      { wch: 16 },
      { wch: 12 },
      { wch: 18 },
      { wch: 18 },
      { wch: 30 },
      { wch: 18 },
      { wch: 24 },
      { wch: 60 },
    ];

    const range = XLSX.utils.decode_range(ws['!ref']);
for (let C = range.s.c; C <= range.e.c; C += 1) {
  const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });

  if (ws[cellAddress]) {
    ws[cellAddress].s = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '1F4E78' } },
      alignment: { horizontal: 'center', vertical: 'center' },
    };
  }
}

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Contact List');

    const excelBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
    });

    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `contact_list_${moment().format('YYYYMMDD_HHmmss')}${fileExtension}`);
  } catch (error) {
    console.error('Export excel error:', error);
  }
};

  const handleOnDetails = () => {
    setOpenDetails(true);
    setOpen(false);
  };

  const handleOnEdit = () => {
    setEmail(selectedItem.email);
    setActivationDate(selectedItem.purchase_date);
    setCity(selectedItem.city);
    setName(selectedItem.full_name);
    setMobileNum(selectedItem.mobile);
    setDialogOpen(true);
    setOpen(false);
  };

  const handleOpenMenu = (event, row) => {
    setSelectedItem(row);
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy2 === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy2(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = row.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - row.length) : 0;

  const filteredUsers = applySortFilter(row, getComparator(order, orderBy2), filterName, select);

  const isNotFound = !filteredUsers.length && !!filterName;

  if (loading) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  const renderStatus = (status) => {
    let _status = '';
    if (status === 'pending_verification') {
      _status = 'Pending Verification';
    } else if (status === 'verified') {
      _status = 'Verified';
    }

    return _status;
  };

  const renderFilePath = (path) => {
    const printUrl = async (_path) => {
      const storage = getStorage(app);
      const _url = await getDownloadURL(ref(storage, _path))
        .then((url) => url)
        .catch((error) => {
          // Handle any errors
        });
      setFileUrl(_url);
    };

    printUrl(path);

    return fileUrl;
  };

  const sourceData =
  selected.length > 0 ? row.filter((item) => selected.includes(item.id)) : filteredUsers;

  return (
    <>
      <Helmet>
        <title> Contact Us | OneT </title>
      </Helmet>

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Edit</DialogTitle>
        <DialogContent>
          <FormControl style={{ marginTop: 20 }} fullWidth>
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select labelId="Status" id="Status" value={statusdevice} label="Status" onChange={handleChangeStatus}>
              <MenuItem value="pending_verification">Pending Verification</MenuItem>
              <MenuItem value="verified">Verified</MenuItem>
            </Select>
          </FormControl>

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={emailaddress}
            onChange={handleChangeEmail}
            autoComplete="off"
            id="outlined-required"
            label="Email Address"
          />

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={cityname}
            onChange={handleChangeCity}
            autoComplete="off"
            id="outlined-required"
            label="City"
          />

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={activationDate}
            onChange={handleChangeActivationDate}
            autoComplete="off"
            id="outlined-required"
            label="Activation Date"
          />

          <TextField
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={name}
            onChange={handleChangeName}
            autoComplete="off"
            id="outlined-required"
            label="Name"
          />

          <PhoneInput
            country="kh"
            inputStyle={{ width: '100%' }}
            containerStyle={{ width: '100%' }}
            style={{ margin: 0, marginTop: 15, width: '100%' }}
            value={mobileNum}
            onChange={handleChangeMobileNum}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>No</Button>
          <Button onClick={handleDialogSubmit} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete event page</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this user?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>No</Button>
          <Button onClick={handleSubmitDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Contact Us
          </Typography>
          
        </Stack>

        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container style={{ maxWidth: 500 }}>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                id="title"
                error={titleError}
                onChange={onHandleTitle}
                label="Title"
                value={title}
                name="title"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
              <TextField
                fullWidth
                required
                onChange={onHandleSubTitle}
                error={subtitleError}
                id="subtitle"
                label="Sub Title"
                name="subtitle"
                value={subtitle}
                autoComplete="off"
              />
            </Grid>

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Submit
            </Button>

            <Grid item xs={12} md={12} style={{ marginTop: 20 }}>
              <MuiFileInput
                color="primary"
                required
                style={{ width: '100%' }}
                error={fileInputError}
                placeholder="Upload Background Video*"
                getInputText={(value) => (value ? value.name : 'Upload Background Video*')}
                inputProps={{ accept: 'video/mp4' }}
                value={file}
                onChange={handleOnChangeUploadfile}
              />
              <Typography style={{ fontSize: 12, color: 'black', marginTop: 10, opacity: 0.6 }}>
                *Video Resolution (W)1920px x (H)1080px
              </Typography>
            </Grid>
            {videobg ? (
              <Grid item xs={12} md={12} style={{ marginTop: 5 }}>
                <video height={50} playsInline autoPlay loop muted>
                  <source src={videobg} type="video/mp4" />
                </video>
              </Grid>
            ) : null}

            <Button onClick={onHandleUploadVideo} fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
              Upload Background Video
            </Button>
          </Grid>
          
        </Box>

        <Card>
          <UserListToolbar
            handleChangeSelect={handleChangeSelect}
            select={select}
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <Button style={{ margin: 10 }} variant="contained" onClick={downloadExcel}>
              Export Excel
            </Button>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy2}
                  headLabel={TABLE_HEAD}
                  rowCount={row.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id } = row;
                    const selectedUser = selected.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, id)} />
                        </TableCell>

                        <TableCell align="left">
                          <Typography align="left" style={{ fontSize: 14 }}>
                            {`${new Date(row.created).getFullYear()}
                        -${new Date(row.created).getMonth() + 1}
                        -${new Date(row.created).getDate()}`}
                          </Typography>
                          <Typography align="left" style={{ fontSize: 14 }}>
                            {`${new Date(row.created).getHours()}: ${new Date(row.created).getMinutes()}`}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">
                          <Typography
                            sx={{
                              fontSize: 14,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                            }}
                          >
                            {row.first_name}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">
                          <Typography
                            sx={{
                              fontSize: 14,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                            }}
                          >
                            {row.last_name}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">
                          <Typography
                            sx={{
                              fontSize: 14,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                            }}
                          >
                            {row.email}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">
                          <Typography
                            sx={{
                              fontSize: 14,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: '2',
                              WebkitBoxOrient: 'vertical',
                            }}
                          >
                            {row.mobile}
                          </Typography>
                        </TableCell>

                        <TableCell
                          style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '11rem' }}
                          align="left"
                        >
                          <Tooltip title={row.message}>
                            <Typography
                              sx={{
                                fontSize: 14,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '2',
                                WebkitBoxOrient: 'vertical',
                              }}
                            >
                              {row.message}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                            <Iconify icon="eva:more-vertical-fill" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
            component="div"
            count={row.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleOnDelete} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
